if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends HTMLElement {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.closeButton = this.querySelector('[id^="ModalClose-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        // Card styles can create a containing block for positioned descendants.
        // Moving the dialog to the document root keeps its overlay viewport-bound.
        if (this.parentElement !== document.body) document.body.append(this);

        this.closeButton?.addEventListener('click', () => this.hide());
        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.hide();
        });
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }

      show(opener) {
        opener.setAttribute('aria-disabled', 'true');
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner')?.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            if (!productElement) throw new Error('Quick view product information was not found.');

            this.preprocessHTML(productElement);
            this.modalContent.replaceChildren(productElement);
            document.documentElement.classList.add('overflow-hidden');
            document.body.classList.add('overflow-hidden');
            this.setAttribute('open', '');
            this.closeButton?.focus();
          })
          .catch((error) => console.error(error))
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      hide() {
        document.documentElement.classList.remove('overflow-hidden');
        document.body.classList.remove('overflow-hidden');
        this.removeAttribute('open');
        this.modalContent.replaceChildren();
      }

      preprocessHTML(productElement) {
        const originalSectionId = productElement.dataset.section;
        const quickViewSectionId = `quickview-${originalSectionId}`;

        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') {
            this.modalContent.classList.add(classApplied);
          }
        });
        productElement.innerHTML = productElement.innerHTML.replaceAll(originalSectionId, quickViewSectionId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(originalSectionId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(originalSectionId, quickViewSectionId));
          }
        });
        productElement.dataset.originalSection = originalSectionId;
        productElement.setAttribute('data-update-url', 'false');

        productElement.querySelector('pickup-availability')?.remove();
        productElement.querySelector('product-modal')?.remove();
        productElement.querySelectorAll('modal-dialog').forEach((modal) => modal.remove());
        productElement
          .querySelectorAll(
            '.fbt-section, .product__tax, .installment, .share-button, .product__inventory, .product__sku'
          )
          .forEach((element) => element.remove());

        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (galleryList) {
          galleryList.setAttribute('role', 'presentation');
          galleryList.querySelectorAll('[id^="Slide-"]').forEach((item) => item.setAttribute('role', 'presentation'));
        }
      }
    }
  );
}
